import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { computed } from 'mobx';
import { Model } from 'core/model/Model';
import { ASSET_TAG_FILTER_PREFIX } from '@kentik/ui-shared/labels/lib';
import AssetTagValueCollection from './AssetTagValueCollection';
let AssetTagModel = (_class = class AssetTagModel extends Model {
  constructor(...args) {
    super(...args);
    this.valueCollection = new AssetTagValueCollection([], {
      assetTagModel: this
    });
  }
  get urlRoot() {
    return '/api/ui/assetTags/keys';
  }
  get urlPaths() {
    return {
      fetch: `/api/ui/assetTags/keys/${this.id}`,
      update: `/api/ui/assetTags/keys/${this.id}`
    };
  }
  get omitDuringSerialize() {
    return ['usage', 'user_id'];
  }
  get keyName() {
    return this.get('display_name') || this.get('name') || 'unknown';
  }

  /**
   * Provides a standard naming convention for tags we expose as admin sidebar filter fields.
   */
  get filterName() {
    return `${ASSET_TAG_FILTER_PREFIX}${this.get('name')}`;
  }

  /**
   * Get a set of entity types that are using this asset tag.
   * @returns A set of entity types that are using this asset tag.
   */
  get entityUsage() {
    return new Set(Object.keys(this.get('usage') || {}));
  }

  /**
   * Provides a lookup table for entity ids to their corresponding values.
   * @returns a hash keyed by entityType:entityId
   */
  get tagLookup() {
    const lookups = {};
    const items = this.get('items') || [];
    items.forEach(({
      entity_type,
      entity_id,
      value
    }) => {
      lookups[`${entity_type}:${entity_id}`] = value;
    });
    return lookups;
  }

  /**
   * Get a set of entity identifiers that are tagged with this asset tag.
   * @returns A set of entity identifiers that are tagged with this asset tag.
   */
  get taggedEntities() {
    return new Set(Object.entries(this.tagLookup).map(([key, value]) => `${key}:${value}`));
  }

  /**
   * Check if an entity is tagged with this asset tag.
   * @param options.relatedAssetModel - The entity model to check.
   * @param options.assetType - The type of the entity.
   * @param options.value - The value of the tag to check.
   * @returns A boolean indicating if the entity is tagged with this asset tag.
   */
  isTagged({
    relatedAssetModel,
    assetType,
    value
  }) {
    return this.taggedEntities.has(`${assetType}:${relatedAssetModel.id}:${value}`);
  }

  /**
   * Returns the value for the given asset model and asset type.
   * @param options.relatedAssetModel - The entity model to check.
   * @param options.assetType - The type of the entity.
   * @returns The value of the tag for the specified entity and asset type, or undefined if not found.
   */
  getTagValue({
    relatedAssetModel,
    assetType
  }) {
    return this.tagLookup[`${assetType}:${relatedAssetModel.id}`];
  }
  serialize(data) {
    const {
      removedIds
    } = this.valueCollection;
    return super.serialize({
      ...(data || this.get()),
      values: {
        del: Array.from(removedIds),
        set: this.valueCollection.serialize()
      }
    });
  }
}, _applyDecoratedDescriptor(_class.prototype, "keyName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "keyName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filterName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "filterName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "entityUsage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "entityUsage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tagLookup", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tagLookup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "taggedEntities", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "taggedEntities"), _class.prototype), _class);
export { AssetTagModel as default };